export default "__VITE_ASSET__205075fe__"